import { Controller } from "stimulus";
import Glide from "@glidejs/glide";

export default class extends Controller {
  connect() {
    this.sliders = document.querySelectorAll(".quote-slider .glide");
    window.addEventListener("load", this.mount.bind(this));
  }

  mount() {
    this.sliders.forEach(slider =>
      new Glide(slider, {
        focusAt: "center",
        perView: 3,
        startAt: 1,
        breakpoints: {
          1200: {
            perView: 1,
            startAt: 0
          }
        }
      }).mount()
    );
  }
}
